export default __webpack_public_path__ + "assets/audio/爱をこめて花束を.66be27df.m4a";